<template>
  <div class="htxt-box__contain" :style="{ 'padding-bottom': paddingBottom }">
    
    <div class="title_box">
      <p class="title">{{ title }}</p>
      <slot name="title_right"></slot>
    </div>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  props: {
    paddingBottom: {
      type: String,
      default: '20px'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.htxt-box__contain {
  padding: 20px 20px 0 20px;
  background-color: #fff;
  .title_box {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
  }
  .title {
    font-size: 16px;
    line-height: 1;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333;
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/box-with-title/index.vue